import React, { FC } from 'react';
import { Form, Layout, Spin } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import styled from 'styled-components';
import CategoriesDragAndDrop from './Components/NewConponents/CategoriesDragAndDrop';
import ProductsByCategoryId from './Components/NewConponents/ProductsByCategoryId';
import shopSelectors from 'services/shop/selectors';

interface IProductsSetting {}

const ProductsSetting: FC<IProductsSetting> = () => {
  const [form] = Form.useForm();
  const categoriesSaga = shopSelectors.data.productCategories();

  // if (categoriesSaga.length === 0) {
  //   return <Spin spinning={true}>Loading...</Spin>;
  // }

  return (
    <ProductsSettingStyled>
      <Form form={form} layout='vertical' style={{ height: '100%' }}>
        <Layout hasSider>
          <Sider width={400} style={siderStyle}>
            <Form.Item name='catId' noStyle initialValue={categoriesSaga?.[0]?.id}>
              <CategoriesDragAndDrop />
            </Form.Item>
          </Sider>
          <Content>
            <Form.Item name='catId' noStyle initialValue={categoriesSaga?.[0]?.id}>
              <ProductsByCategoryId />
            </Form.Item>
          </Content>
        </Layout>
      </Form>
    </ProductsSettingStyled>
  );
};
export default ProductsSetting;

const ProductsSettingStyled = styled.div`
  height: 100%;
  .ant-layout {
    height: 100%;
  }
`;

const siderStyle: React.CSSProperties = {
  borderRight: '1px solid #ccd4dc',
  background: '#fff',
  height: '100%',
};
